<template>
  <v-container grid-list-md fluid>
    <v-layout row wrap>
      <v-flex xs12>
        <!-- CRUD table -->
        <v-card>
          <v-card-title class="primary white--text">
            <!-- Add Entry dialog and button -->
            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on }">
                <v-btn class="success mb-2" dark v-on="on">Add Entry</v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field v-model="editedItem.name" label="Name"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field v-model="editedItem.address" label="Address"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field v-model="editedItem.tel" label="telephone"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field v-model="editedItem.email" label="email"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field v-model="editedItem.products" label="products"></v-text-field>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                  <v-btn color="blue darken-1" text @click="save">Save</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-spacer></v-spacer>
            <!-- Search Field -->
            <v-text-field
              dark
              v-model="search"
              append-icon="search"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <!-- Main data table -->
          <v-data-table dense :headers="headers" :items="orders" sort-by="name" :search="search">
            <template v-slot:item.action="{ item }">
              <v-icon small class="mr-2" @click="editItem(item)">edit</v-icon>
              <v-icon small @click="deleteItem(item)">delete</v-icon>
            </template>
            <template v-slot:no-data>
              <v-btn color="primary" @click="initialize">Reset</v-btn>
            </template>
          </v-data-table>
          <!-- End of CRUD table -->
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import db from "@/fb";
export default {
  data: () => ({
    dialog: false,
    timeline: false,

    items: [
      "Doors",
      "Frame",
      "Timber Section",
      "Screens",
      "Glass",
      "Ironmongory"
    ],
    search: "",
    name: "",
    address: "",
    tel: "",
    email: "",
    products: "",

    loading: false,
    product: "",
    select: "",
    code: "",
    headers: [
      {
        text: "Name",
        align: "left",
        value: "name"
      },
      {
        text: "Address",
        align: "left",
        value: "address",
        sortable: false
      },
      {
        text: "Tel",
        align: "left",
        value: "tel",
        sortable: false
      },
      {
        text: "email",
        align: "left",
        value: "email"
      },
      {
        text: "products",
        align: "left",
        value: "products"
      },
      { text: "Actions", value: "action", sortable: false }
    ],

    orders: [],
    drawer: false,
    status: null,
    TEST: [],
    editedIndex: -1,
    timelineItem: {
      name: "",
      address: "",
      tel: "",
      email: "",
      products: ""
    },
    editedItem: {
      name: "",
      address: "",
      tel: "",
      email: "",
      products: ""
    },
    defaultItem: {
      name: "",
      address: "",
      tel: "",
      email: "",
      products: ""
    },
    newTest: null
  }),

  computed: {
    /*phonebook(){
      this.newTest = this.$store.getters.book
      return this.newTest
    },*/
    /*testOrders () {
      this.TEST = this.$store.getters.orders
      return this.TEST
      }, */
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Item";
    },
    authenticated() {
      return JSON.parse(localStorage.getItem("authenticated"));
    }
  },
  //comment
  mounted() {
    console.log("App mounted!");
    //this.$store.dispatch('fetchBook')
    //comment
    //comment
    //comment
  },
  watch: {
    dialog(val) {
      val || this.close();
    }
  },

  created() {
    db.collection("phonebook").onSnapshot(res => {
      const changes = res.docChanges();
      changes.forEach(change => {
        if (change.type === "added") {
          this.orders.push({
            ...change.doc.data(),
            id: change.doc.id
          });
        }
      });
    });
  },

  methods: {
    getInfo(item) {
      this.timelineIndex = this.orders.indexOf(item);
      this.timelineItem = Object.assign({}, item);

      this.drawer = true;
    },
    editItem(item) {
      this.editedIndex = this.orders.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      const index = this.orders.indexOf(item);
      confirm("Are you sure you want to DElETE this Entry??") &&
        this.orders.splice(index, 1);
      db.collection("phonebook")
        .doc(item.id)
        .delete();
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      console.log(this.editedItem.id);
      if (this.editedIndex > -1) {
        Object.assign(this.orders[this.editedIndex], this.editedItem);
      } else {
        this.orders.push(this.editedItem);
      }

      this.close();
      db.collection("phonebook")
        .doc(this.orders[this.editedIndex].id)
        .update({
          name: this.editedItem.name,
          address: this.editedItem.address,
          tel: this.editedItem.tel,
          email: this.editedItem.email,
          products: this.editedItem.products
        })
        .then(() => {
          this.$emit("Delivered");
        });
    },
    submit() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        var splitName = this.name.toLowerCase().split(" ");
        var splitProd = this.products.toLowerCase().split(" ");
        var newName = "";
        var newProd = "";

        for (var i = 0; i < splitName.length; i++) {
          splitName[i] =
            splitName[i].charAt(0).toUpperCase() + splitName[i].substring(1);
        }
        newName = splitName.join(" ");
        console.log(splitName);

        for (var j = 0; j < splitProd.length; j++) {
          splitProd[j] =
            splitProd[j].charAt(0).toUpperCase() + splitProd[j].substring(1);
        }
        newProd = splitProd.join(" ");

        const entry = {
          name: newName,
          address: this.address,
          tel: this.tel,
          email: this.email,
          products: newProd
        };

        db.collection("phonebook")
          .add(entry)
          .then(() => {
            console.log("ADDED to db");
            this.loading = false;
            this.dialog = false;
            this.$emit("orderCreated");
          });
      }
    }
  }
};
</script>
<style>
table.v-table tbody td:first-child,
table.v-table tbody td:not(:first-child),
table.v-table tbody th:first-child,
table.v-table tbody th:not(:first-child),
table.v-table thead td:first-child,
table.v-table thead td:not(:first-child),
table.v-table thead th:first-child,
table.v-table thead th:not(:first-child) {
  padding: 0 7px;
}
</style>
